import PropTypes from 'prop-types'
import React from 'react'
import { Form } from 'semantic-ui-react'

import { EmailInput } from 'components/EmailInput'

export default function LoginEmailInput({ value, onChange }) {
  return (
    <Form.Field>
      <label>Email</label>
      <EmailInput
        value={value}
        onChange={onChange}
        // @ts-ignore
        autoComplete="username"
      />
    </Form.Field>
  )
}

LoginEmailInput.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/Login/EmailInput/index.js